import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { GET_SCHD_CLASS_STD_NEXT } from './APIs';
import { ConvertEventItemStudent } from './_core';
import { AlertNotif } from '../../../../../Library/AlertNotif';
import LoadingBtn from '../../../../Widgets/LoadingBtn';
import CalendarMonth from './CalendarMonth';

export default function MyCalendars({ student }) {
    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment()
        .endOf("month")
        .add(7, "days")
        .format("YYYY-MM-DD");

    const [start_date, setStartDate] = useState(startOfMonth);
    const [end_date, setStartEnd] = useState(endOfMonth);
    const [schedules, setSchedules] = useState({ loading: false, data: [], message: "" });

    const Get_schedule = async (param) => {
        setSchedules({ loading: true, data: [], message: "" });
        const results = await GET_SCHD_CLASS_STD_NEXT(param);
        if (results.data && Object.values(results.data).length > 0) {
            const event_schd = ConvertEventItemStudent(results.data);
            setSchedules({ loading: false, data: event_schd, message: "" });
        } else {
            setSchedules({ loading: false, data: [], message: "" });
        }
    }

    useEffect(() => {
        Get_schedule({ studentid: student.studentid, tgl: start_date, tglend: end_date });
    }, [start_date, end_date]);
    return (
        <div className='bg-white border rounded mb-5'>
            {schedules.loading && (
                <div className="position-absolute bg-light pr-8 rounded" style={{ zIndex: 9, left: '35%' }}>
                    <div className="d-flex align-items-center">
                        <LoadingBtn />
                        <span className="font-style-italic">Processing...</span>
                    </div>
                </div>
            )}

            {schedules.message && (
                <div className="my-5 px-8">
                    <AlertNotif title={"Timetable Generate"} messages={schedules.message} />
                </div>
            )}

            <CalendarMonth
                title={"Timetables"}
                is_student={true}
                start_date={start_date}
                setStartDate={setStartDate}
                end_date={end_date}
                setStartEnd={setStartEnd}
                data={schedules.data} />
        </div>
    )
}
